import React, { useState } from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Button, Grid, TextField, Box, MenuItem } from '@mui/material'
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import { Api } from '../../components/api';
import { useSnackbar } from 'notistack';
import { DatePicker, LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { fDateTo } from '../../utils/formatTime';
import * as Yup from 'yup';
import { Form, FormikProvider, useFormik } from 'formik';

export default function AddDevice({ account, handleGetData }) {
    const { c_coname, contype, cogcode, cocode } = account;

    const initial = {
        "device": "",
        "gpsmodel": "",
        "devicename": "",
        "province_code": "",
        "vehicle_register_type": "",
        "vehicle_type": "",
        "vehicle_id": "",
        "card_reader": true,
        "unit_id": "",
        "imei": "",
        "telgps": "",
        "vehicle_chassis_no": "",
        "dateinstall": fDateTo(new Date(), "yyyy-MM-dd"),
        "dateexp": fDateTo(new Date(), "yyyy-MM-dd"),
        "dlt_status": true,
        "car_id": "",
        "cname": c_coname,
        "group_id": ""
    }

    const [open, setOpen] = useState(false)
    const [cnames, setcnames] = useState([])
    const [groups, setGroups] = useState([])
    const [modelGps, setModelGps] = useState([])
    const [provinces, setProvinces] = useState([])
    const [vehiclesType, setVehiclesType] = useState([])
    const [vehicleRegisterType, setVehicleRegisterType] = useState([])
    const getDataMaster = () => {

        Api.get(`/v0/gps/province?cocode=${cocode}`)
            .then(res => {
                setProvinces(res.data)
            }
            )
        Api.get(`/v0/gps/vehicle_types?cocode=${cocode}`)
            .then(res => {
                setVehiclesType(res.data)
            }
            )
        Api.get(`/v0/gps/vehicle_register?cocode=${cocode}`)
            .then(res => {
                setVehicleRegisterType(res.data)

            }
            )
        Api.get(`v0/gps/gpsmodels?cocode=${cocode}`)
            .then(res => {
                setModelGps(res.data)
            })
    }


    const onGetCompany = () => {
        Api.get(`/v0/if/Cnames`, { headers: { CompanyGroup: cogcode } })
            .then((res) => {
                setcnames(res.data)
            })
            .catch((err) => {
                console.log('err', err)
            })
    }
    const onGetGroup = () => {
        Api.get(`/Tracking/Group?cname=${c_coname}`, { headers: { CompanyGroup: cogcode } })
            .then((res) => {
                setGroups(res.data)
            })
    }
    const onClickOpen = () => {
        setOpen(true)
        onGetCompany()
        onGetGroup()
        getDataMaster()
    }
    const onClickClose = () => {
        setOpen(false)
    }
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const handleSnackbar = ({ message, variant }) => {
        enqueueSnackbar(message,
            {
                autoHideDuration: 1000,
                anchorOrigin: {
                    horizontal: "right",
                    vertical: 'bottom'
                },
                variant: variant
            });
    }
    const schema = Yup.object().shape({
        device: Yup.string().required('required'),
        devicename: Yup.string().required('required')
    });
    const formik = useFormik({
        initialValues: {
            "device": "",
            "gpsmodel": "",
            "devicename": "",
            "province_code": "",
            "vehicle_register_type": "",
            "vehicle_type": "",
            "vehicle_id": "",
            "card_reader": true,
            "unit_id": "",
            "imei": "",
            "telgps": "",
            "vehicle_chassis_no": "",
            "dateinstall": fDateTo(new Date(), "yyyy-MM-dd"),
            "dateexp": fDateTo(new Date(), "yyyy-MM-dd"),
            "dlt_status": true,
            "car_id": "",
            "cname": c_coname,
            "group_id": ""
        },
        validationSchema: schema,
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            const data = JSON.stringify({
                ...values
            });
            Api.post('/v0/gps/device', data)
                .then(res => {
                    handleSnackbar({ message: "บันทึกข้อมูลสำเร็จ", variant: "success" })
                    onClickClose()
                    handleGetData()
                    resetForm()
                })
                .catch(error => {
                    handleSnackbar({ message: "ไม่สามารถบันทึกข้อมูล", variant: "error" })
                })
        }
    });
    const { errors, touched, isSubmitting, values, setFieldValue, handleSubmit, getFieldProps, setErrors, resetForm, submitForm } = formik;

    const onChangeDate = (value, name) => {
        if (String(value) === "Invalid Date") {
            setFieldValue(name, value)
        } else {
            setFieldValue(name, fDateTo(value, "yyyy-MM-dd"))
        }
    }

    return (
        <div>
            <IconButton onClick={onClickOpen}>
                <AddBoxOutlinedIcon />
            </IconButton>
            <Dialog
                open={open}
                maxWidth="md"
                fullWidth={true}
                onClose={onClickClose}
                slotProps={{
                    backdrop: {
                        style: {
                            background: "#a7d8de",
                            opacity: 0.2
                        }
                    }
                }}
            >
                <DialogTitle>เพิ่มอุปกรณ์</DialogTitle>
                <DialogContent dividers>
                    <Box sx={{ padding: "10px" }}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <FormikProvider value={formik}>
                                <Form autoComplete="off" noValidate onSubmit={handleSubmit}  >
                                    <Grid container spacing={1} >
                                        <Grid item xs={6}>
                                            <Grid container spacing={1} >
                                                <Grid item xs={12}>
                                                    <TextField size="small" fullWidth label="รหัสอุปกรณ์" name="device"
                                                        {...getFieldProps('device')}
                                                        error={Boolean(touched.device && errors.device)}
                                                        helperText={touched.device && errors.device}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField size="small" fullWidth label="ชื่ออุปกรณ์" name="devicename"
                                                        {...getFieldProps('devicename')}
                                                        error={Boolean(touched.group_id && errors.devicename)}
                                                        helperText={touched.devicename && errors.devicename}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField size="small" fullWidth label="รุ่น GPS" select name="gpsmodel" {...getFieldProps('gpsmodel')} >
                                                        {
                                                            modelGps.map((value, index) => {
                                                                return (
                                                                    <MenuItem value={value.gpstype} key={`MenuItem${index}`}>{`${value.gpsmodel}/${value.gpstype}`}</MenuItem>
                                                                )
                                                            })
                                                        }
                                                    </TextField>
                                                </Grid>
                                                <Grid item xs={12}><TextField size="small" fullWidth label="เลข imei" name="imei" {...getFieldProps('imei')} /></Grid>
                                                <Grid item xs={12}>
                                                    <TextField size="small" fullWidth label="เบอร์โทร GPS" name="telgps" {...getFieldProps('telgps')} />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField size="small" fullWidth label="ผู้ประกอบการขนส่ง" name="cname" select {...getFieldProps('cname')}
                                                        disabled={(contype !== "00" && contype !== "01")}
                                                    >
                                                        {
                                                            cnames.map((value, index) => {
                                                                return (
                                                                    <MenuItem value={value.c_coname} key={`MenuItem0${index}`}>{value.fullname}</MenuItem>
                                                                )
                                                            })
                                                        }
                                                    </TextField>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField size="small" fullWidth label="กลุ่ม" name="group_id" select {...getFieldProps('group_id')}
                                                    // disabled={contype !== "00"}
                                                    >
                                                        {
                                                            groups.map((value, index) => {
                                                                return (
                                                                    <MenuItem value={value.group_id} key={`MenuItem1${index}`}>{value.group_name}</MenuItem>
                                                                )
                                                            })
                                                        }
                                                    </TextField>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Grid container spacing={1} >
                                                <Grid item xs={12}><TextField size="small" fullWidth label="เลขตัวถัง" name="vehicle_chassis_no" {...getFieldProps('vehicle_chassis_no')} /></Grid>
                                                <Grid item xs={12}>
                                                    <TextField size="small" fullWidth label="ยี่ห้อรถ" select name="vehicle_type" {...getFieldProps('vehicle_type')} >
                                                        {
                                                            vehiclesType.map((value, index) => {
                                                                return (
                                                                    <MenuItem value={value.vehicle_type} key={`MenuItem2${index}`}>{value.vehicle_type}</MenuItem>
                                                                )
                                                            })
                                                        }
                                                    </TextField>
                                                </Grid>
                                                <Grid item xs={12}><TextField size="small" fullWidth label="ชื่อรถ" name='car_id' {...getFieldProps('car_id')} /></Grid>
                                                <Grid item xs={12}><TextField size="small" fullWidth label="ทะเบียน" name='vehicle_id' {...getFieldProps('vehicle_id')} /></Grid>
                                                <Grid item xs={12}>
                                                    <TextField size="small" fullWidth label="จังหวัด" select name="province_code" {...getFieldProps('province_code')} >

                                                        {
                                                            provinces.map((value, index) => {
                                                                return (
                                                                    <MenuItem value={value.province_code} key={`MenuItem3${index}`}>{value.province_name}</MenuItem>
                                                                )
                                                            })
                                                        }
                                                    </TextField>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField size="small" fullWidth label="ประเภทรถ" select name='vehicle_register_type' {...getFieldProps('vehicle_register_type')} >
                                                        {
                                                            vehicleRegisterType.map((value, index) => {
                                                                return (
                                                                    <MenuItem value={value.vehicle_register_type_id} key={`MenuItem4${index}`}>{value.vehicle_register_type_name}</MenuItem>
                                                                )
                                                            })
                                                        }
                                                    </TextField>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <DatePicker
                                                        onChange={(e) => { onChangeDate(e, "dateinstall") }}
                                                        value={values.dateinstall}
                                                        inputFormat="dd/MM/yyyy"
                                                        format="yyyy/MM/dd"
                                                        label="วันที่ติดตั้ง"
                                                        renderInput={(params) => <TextField size="small" placeholder="DD/MM/YYYY"  {...params} />}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <DatePicker
                                                        onChange={(e) => { onChangeDate(e, "dateexp") }}
                                                        value={values.dateexp}
                                                        inputFormat="dd/MM/yyyy"
                                                        format="yyyy/MM/dd"
                                                        label="วันหมดอายุ"
                                                        renderInput={(params) => <TextField size="small" placeholder="DD/MM/YYYY"  {...params} />}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}><TextField size="small" fullWidth label="unit id" name='unit_id' {...getFieldProps('unit_id')} /></Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Form>
                            </FormikProvider>
                        </LocalizationProvider>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={submitForm}>บันทึก</Button>
                    <Button onClick={onClickClose}>ยกเลิก</Button>
                </DialogActions>
            </Dialog>
        </div >
    )
}
